import component from './crossSales.vue'

export default component
